import type { MemberRole } from '../api/generated/MemberRole'

/** A section of an event space, at `/events/{slug}{path}`. */
export type Section = {
  path: string
  label: string
  /** Shown in the mobile tab bar, under this shorter label; the others are under "Plus". */
  tab?: string
  badge?: 'pending' | 'unread'
  /** At the bottom of the side menu, apart from the others. */
  apart?: boolean
}

export const organizerSections: Section[] = [
  { path: '/', label: 'Tableau de bord', tab: 'Accueil' },
  { path: '/planning', label: 'Planning', tab: 'Planning' },
  { path: '/volunteers', label: 'Bénévoles', tab: 'Bénévoles', badge: 'pending' },
  { path: '/messages', label: 'Messages', tab: 'Messages', badge: 'unread' },
  { path: '/announcements', label: 'Annonces' },
  { path: '/positions', label: 'Postes et fiches' },
  { path: '/stats', label: 'Statistiques' },
  { path: '/settings', label: 'Réglages', apart: true },
]

export const volunteerSections: Section[] = [
  { path: '/', label: 'Accueil', tab: 'Accueil' },
  { path: '/planning', label: 'Mon planning', tab: 'Planning' },
  { path: '/messages', label: 'Messages', tab: 'Messages', badge: 'unread' },
  { path: '/availability', label: 'Mes disponibilités', tab: 'Dispos' },
  { path: '/positions', label: 'Postes', tab: 'Postes' },
]

export const sectionsOf = (role: MemberRole): Section[] =>
  role === 'organizer' ? organizerSections : volunteerSections

/** Pages under another section's path: a conversation or a group belongs to the messages. */
const parents: Record<string, string> = { conversations: '/messages', groups: '/messages' }

/** The section of `rest`, the path after `/events/{slug}`; the first one for an unknown path. */
export function sectionOf(sections: Section[], rest: string): Section {
  const segment = rest.split('/').find(Boolean)
  const path = segment ? (parents[segment] ?? `/${segment}`) : '/'
  return sections.find((section) => section.path === path) ?? sections[0]
}
